import Progress from 'redux-progress';
import { Selector } from 'model/State';

const selectCurrency: Selector<Progress<string>> = (state) =>
  state.cart.payload.map((p) => p && p.currency);

export default selectCurrency;
